import { Pool } from 'state/data/slice'

export type PoolType = 'major' | 'lst' | 'eco'

export interface PoolCardProps {
  type?: PoolType
  pools?: Pool[]
  isLoading?: boolean
}

export const typeConfig = {
  major: {
    background: 'rgba(247, 147, 26, 0.16)',
    textGradient: 'linear-gradient(180deg, #FFE2BF 18.75%, #F7931A 73.75%)',
    svgGradient: 'linear-gradient(180deg, #FFE2BF 0%, #F7931A 100%)',
    label: 'Major',
  },
  lst: {
    background: 'rgba(254, 243, 199, 0.16)',
    textGradient: 'linear-gradient(180deg, #FFFAE8 18.75%, #FEF3C7 73.75%)',
    svgGradient: 'linear-gradient(180deg, #FFFAE8 0%, #FEF3C7 100%)',
    label: 'Lst',
  },
  eco: {
    background: 'rgba(138, 62, 18, 0.16)',
    textGradient: 'linear-gradient(180deg, #EFC7A6 32.5%, #AB8F78 87.5%)',
    svgGradient: 'linear-gradient(180deg, #EFC7A6 0%, #AB8F78 100%)',
    label: 'Eco',
  },
}
